import { h } from "@stencil/core";
import { BoxType } from "../../shared/models/atoms/bbg-box/box-type.enum";
import { renderInlineError } from "../../../utils";
export class BbgBox {
  constructor() {
    /** The box's type. Possible values: nonModal, modal */
    this.type = BoxType.nonModal;
    /** Switches on and off the visibility of the box. */
    this.show = false;
  }
  render() {
    if (BoxType[this.type] === undefined) {
      return renderInlineError(`Unknown box type '${this.type}'`);
    }
    const boxCssClasses = {
      "a-box": true,
      "-floating": true,
      "-hide": this.type !== BoxType.modal && this.show !== true,
      "-show": this.type !== BoxType.modal && this.show === true,
    };
    const box = (h("div", { class: boxCssClasses }, h("slot", null)));
    if (this.type === BoxType.nonModal) {
      return box;
    }
    const modalBoxCssClasses = {
      "a-box--modal": true,
      "-show": this.show === true,
    };
    return h("div", { class: modalBoxCssClasses }, box);
  }
  static get is() { return "bbg-box"; }
  static get originalStyleUrls() {
    return {
      "$": ["bbg-box.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["bbg-box.css"]
    };
  }
  static get properties() {
    return {
      "type": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The box's type. Possible values: nonModal, modal"
        },
        "attribute": "type",
        "reflect": false,
        "defaultValue": "BoxType.nonModal"
      },
      "show": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Switches on and off the visibility of the box."
        },
        "attribute": "show",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
}
